import React, { memo, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Divider } from '@mui/material';
import { makeStyles } from '@mui/styles';
import ReactList from 'react-list';

import palette from '../../../styles/palette';
import { useRouteClicks } from '../../../../hooks/useRouteClicks';
import { getCard, getCardSize } from '../../../../models/UI';
import { getScrollToRoute } from '../../../../store/selectors/routes';
import { resetScrollToRoute } from '../../../../store/reducers/routes';
import { getDepotWeightException } from '../../../../store/selectors/depot';

const colors = [palette.map.key1, palette.map.key2, palette.map.key3];

const useStyles = makeStyles(() => ({
  divider: {
    height: '0.125rem',
    background: 'transparent',
  },
}));

const ListView = ({
  routes,
  selectedTab,
  selectedRoute,
  onRouteCodeClick,
  onStatusChange,
  onLockChange,
  onOpenLockRoutePopover,
}) => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const [onClick, onDoubleClick] = useRouteClicks();
  const listRef = useRef();
  const scrollToRoute = useSelector(getScrollToRoute);
  const hideWeightException = useSelector(getDepotWeightException);

  const scrollListTo = useCallback(
    (scrollToRouteId) => {
      const selectedStopIndex = routes.findIndex(
        (route) => route.routeId === scrollToRouteId
      );
      listRef.current.scrollTo(selectedStopIndex);
    },
    [routes]
  );

  // manually scroll to route
  useEffect(() => {
    if (routes?.length > 1 && scrollToRoute) {
      scrollListTo(scrollToRoute);
      dispatch(resetScrollToRoute());
    }
  }, [scrollToRoute, scrollListTo, routes, dispatch]);

  // scroll to selected route only if changed selectedTab
  useEffect(() => {
    if (selectedRoute) {
      scrollListTo(selectedRoute);
    }
  }, [selectedTab]);

  return (
    <ReactList
      ref={listRef}
      threshold={400}
      length={routes.length}
      itemSizeGetter={(index) =>
        getCardSize(selectedTab, routes[index].defaultRoute)
      }
      type={'variable'}
      itemRenderer={(index, key) => {
        const route = routes[index];
        const Component = getCard(selectedTab, route);

        return (
          <div key={key}>
            <Divider className={styles.divider} />
            <Component
              showLockRoute
              showWightException={!hideWeightException}
              route={route}
              spot={colors[index % 3]}
              active={selectedRoute === route.routeId}
              onClick={() => onClick(route)}
              onDoubleClick={() => onDoubleClick(route)}
              onRouteCodeClick={() => onRouteCodeClick(route)}
              onStatusChange={onStatusChange}
              onLockChange={() => onLockChange(route)}
              onOpenLockRoutePopover={onOpenLockRoutePopover}
            />
          </div>
        );
      }}
    />
  );
};
export default memo(ListView);
